import { TagChip, TagChipRow } from '@/features/report/Tags';
import { formatTagLabel } from '@/shared/utils/tagLabel';
import styles from './TagsSection.module.css';

interface TagsSectionProps {
  tags: string[];
}

export default function TagsSection({ tags }: TagsSectionProps) {
  if (tags.length === 0) return null;

  return (
    <TagChipRow className={styles.section}>
      {tags.map((tag) => (
        <TagChip key={tag} value={tag} label={formatTagLabel(tag)} />
      ))}
    </TagChipRow>
  );
}
